













import { vxm } from '@/store.vuex';
import { Component, Vue } from 'vue-property-decorator';

import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import router from '../router';

@Component({
  name: 'ThankYouQuickRegister',
  components: {}
})

export default class ThankYouQuickRegister extends Vue{
    
}
